export type RemLike = `${number}rem`;

export function rem(px: number): RemLike {
	return `${px / 16}rem`;
}

export function remToNumber(remValue: RemLike): number {
	const strippedRem = remValue.replace('rem', '');
	const value = parseInt(strippedRem, 10);

	if (isNaN(value)) {
		// We could throw here but it's better to be safe I guess ¯\_(ツ)_/¯
		return 16;
	}

	return value * 16;
}
